<template>
  <v-app-bar
    :fixed="!esDesktop || (esDesktop && esDocumento)"
    :app="!esDesktop || (esDesktop && esDocumento)"
    flat
    class="light-background app-bar"
    extension-height="10px"
  >
    <div class="info-guia d-flex flex-column">
      <div class="d-flex flex-row justify-space-between align-center">
        <v-btn
          v-if="obtenerInfoGuia.esVisibleUrlRetroceso"
          color="primary"
          fab
          x-small
          @click="$router.push(obtenerInfoGuia.urlRetroceso)"
          ><v-icon light>mdi-arrow-left</v-icon></v-btn
        >
        <div v-else>&nbsp;</div>
        <span>{{ obtenerInfoGuia.descripcionPasoCompleta }}</span>
        <div>
          <v-btn
            v-if="obtenerInfoGuia.esVisibleBtnDescargar"
            :href="obtenerInfoGuia.urlDocumento"
            download
            class="mr-2"
            color="primary"
            fab
            x-small
          >
            <v-icon light>mdi-download</v-icon>
          </v-btn>
          <v-dialog
            v-model="modalGuia"
            width="100%"
            scrollable
            overlay-opacity="0.9"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="jello-horizontal"
                color="secondary"
                x-small
                v-bind="attrs"
                v-on="on"
                fab
                ><v-icon>mdi-help</v-icon>
              </v-btn>
            </template>
            <div>
              <div class="guia">
                <v-row justify="center">
                  <v-col cols="10" xs="10" sm="10" md="6" lg="6" xl="6">
                    <div
                      class="d-flex flex-row justify-end align-end mt-8 mb-3"
                    >
                      <v-btn color="primary" fab small @click="cerrarGuia">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </div>
                    <v-card class="texto-guia">
                      <v-card-text v-html="obtenerInfoGuia.contenidoGuia">
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-dialog>
        </div>
      </div>
    </div>
    <template #extension v-if="obtenerInfoGuia.esProgresoVisible">
      <v-progress-linear
        :value="obtenerInfoGuia.avance"
        height="10"
        background-color="#f3f6fb"
        striped
      ></v-progress-linear>
    </template>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  name: 'Toolbar',
  props: {
    esDocumento: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [InsertaLogMixin],
  data: () => ({
    modalGuia: false,
    infoGuia: null,
    mostrarSnackbar: false,
  }),
  watch: {
    modalGuia: {
      handler: function (v) {
        if (v) {
          this.$gtag.event('abreAyuda', {
            event_category: 'change_in_window',
            event_label: 'Se abrio la ayuda guia',
            value: this.infoGuia.descripcionPaso,
          })
          this.InsertaLog({
            notas: 'Se abrio la ayuda guia en' + this.infoGuia.descripcionPaso,
          })
        }
      },
      deep: true,
    },
  },
  methods: {
    cerrarGuia() {
      this.modalGuia = false
    },
    mostrarAlert() {
      alert('Te llamaremos en breve')
    },
  },
  computed: {
    esDesktop() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return false
        case 'sm':
          return false
        case 'md':
          return true
        case 'lg':
          return true
        case 'xl':
          return true
        default:
          return true
      }
    },
    ...mapGetters({
      obtenerInfoGuia: 'guia/obtenerInfoGuia',
    }),
    esCreditoEditable() {
      const esCreditoEditable =
        this.$store.getters['credito/actualizarEditable']
      return esCreditoEditable ? true : false
    },
  },
  created() {
    this.infoGuia = this.obtenerInfoGuia
    this.$gtag.event('infoGuia', {
      event_category: 'change_in_window',
      event_label: 'Se generá una guia',
      value: this.infoGuia.descripcionPaso,
    })
  },
}
</script>

<style scoped>
.light-background {
  background-color: #f3f6fb !important;
}
.guia {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
}
.guia-body {
  box-shadow: none;
  background-color: none;
}
.texto-guia {
  max-height: 80vh;
  overflow-y: auto;
}
.info-guia {
  width: 100%;
}
.v-toolbar__extension {
  padding: 4px 0px !important;
}

.jello-horizontal {
  -webkit-animation: jello-horizontal 6s infinite both;
  animation: jello-horizontal 6s infinite both;
}

@-webkit-keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  2% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  4% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  6% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }
  8% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  10% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  12% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  2% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  4% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  6% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }
  8% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  10% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  12% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
</style>
